import { useQuery } from '@apollo/client'
import { useAuth } from 'context/AuthProvider'

import { atlasClient } from 'graphql/client'

import { GET_NEW_INVITATIONS_COUNT } from './connectionsMenuOption.queries'

export const useNewConnectionsCount = () => {
  const { isAuthenticated } = useAuth()
  const { data } = useQuery(GET_NEW_INVITATIONS_COUNT, {
    client: atlasClient,
    skip: !isAuthenticated,
  })
  return {
    newConnectionsCount: data?.newInvitationCount?.count ?? 0,
  }
}
